import { useEffect, useState } from 'react'

import { SkeletonRows } from '@/components/ui/skeleton'
import { TrucksTable } from '../../../../components/TrucksTable'
import { type Truck, useTrucks } from '../../../../models/equipment'

export function TrucksTab({ orgId }: { orgId: string }) {
  const { trucks, isLoading } = useTrucks({ shouldFetchAllPages: true, orgId })
  const [selectedTrucks, setSelectedTrucks] = useState<Truck[]>([])

  useEffect(() => {
    setSelectedTrucks(trucks)
  }, [trucks])

  if (isLoading) {
    return <SkeletonRows />
  }

  return (
    <TrucksTable
      trucks={selectedTrucks}
      setTrucks={setSelectedTrucks}
      addCtaOnTop
      searchable
      orgId={orgId}
      hideHeading
    />
  )
}
